import { render } from "./ForwardIcon.svg?vue&type=template&id=c731ea2e"
const script = {}
script.render = render

export default script